module.exports = __webpack_public_path__ + "static/media/icons8-marker.81d49f4e.png";